"use client";

import { useEffect } from 'react';
import { lazyLoadImages, optimizeFontLoading } from '@/lib/performance';
import { ConsentManager } from '@/components/compliance/ConsentManager';
import { initGA } from '@/lib/analytics';
import siteConfig from '@/config/siteConfig';

export default function PerformanceOptimizer() {
  useEffect(() => {
    lazyLoadImages();
    optimizeFontLoading();

    const animatedElements = document.querySelectorAll('.animate-on-scroll');

    if (animatedElements.length > 0 && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('animated');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );

      animatedElements.forEach((el) => observer.observe(el));

      return () => {
        animatedElements.forEach((el) => observer.unobserve(el));
        observer.disconnect(); // Optimize cleanup
      };
    }

    const preconnectLinks = siteConfig.performance.preconnectDomains;

    preconnectLinks.forEach((url) => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = url;
      document.head.appendChild(link);

      const dnsLink = document.createElement('link');
      dnsLink.rel = 'dns-prefetch';
      dnsLink.href = url;
      document.head.appendChild(dnsLink); // Fixed bug
    });

    const nonCriticalCSS = document.querySelectorAll('link[data-critical="false"]');
    nonCriticalCSS.forEach((link) => {
      link.setAttribute('media', 'print');
      link.setAttribute('onload', "this.media='all'");
    });

    // Initialize analytics if consent is given
    window.addEventListener('enableAnalytics', initGA);

    return () => {
      window.removeEventListener('enableAnalytics', initGA);
    };
  }, []);

  return <ConsentManager />;
}